import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgSeeds = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height={20}
        width={21}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <title>seeds</title>
        <path
            d="M14.8486 6.43359H17.998V7.91699C17.998 9.19418 17.4909 10.4191 16.5879 11.3223C15.6846 12.2256 14.4591 12.7334 13.1816 12.7334H10.498V16.9004H10.0312V11.6777L10.0469 10.8633C10.1438 9.65964 10.6898 8.53643 11.5762 7.71582C12.4665 6.89153 13.6353 6.43355 14.8486 6.43359ZM5.26562 3.09961C6.36406 3.09933 7.43493 3.44484 8.32617 4.08691C9.11299 4.65378 9.72403 5.42709 10.0957 6.31738C9.53962 6.85202 9.07656 7.47724 8.72852 8.16797C8.401 8.81801 8.18243 9.51588 8.0752 10.2334H7.76465C6.3768 10.2333 5.04582 9.68156 4.06445 8.7002C3.08311 7.71877 2.53125 6.38789 2.53125 5V3.09961H5.26562Z"
            stroke="currentColor"
            strokeWidth="1.2"
        />
    </svg>
);

export const SeedsIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgSeeds}
        fontSize={fontSize}
    />
);
